import {combine, forward, merge, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {initFiltersTable} from 'core/hooks/grid2.0';

import {mapFilters} from 'utils/grid-mappers';

import {aggregationForm$, AggregationGate} from '../../index';

import {
    data$,
    defaultFilters,
    fetchDataFx,
    filters$,
    filtersChanged,
    filtersReset,
    Gate,
    gridCacheReset,
    gridTokensCache$,
    pageNumber$,
    pageSize$,
    search$,
    searchChanged,
    stateReset,
    tableStateCacheChanged,
    tableStateChanged,
} from './index';

data$.on(fetchDataFx.done, (_, {result}) => result).reset(AggregationGate.close);
search$.on(searchChanged, (_, value) => value).reset(AggregationGate.close);
pageNumber$.reset(stateReset);
pageSize$.reset(stateReset);

gridTokensCache$
    .on(fetchDataFx.done, (state, {result}) => ({
        ...state,
        [pageNumber$.getState() + 1]: result.nextPageRef ?? null,
    }))
    .on(gridCacheReset, () => ({0: null}));

initFiltersTable(filters$, filtersChanged, filtersReset, defaultFilters, stateReset);

forward({
    from: tableStateCacheChanged,
    to: gridCacheReset,
});

sample({
    clock: merge([Gate.open, tableStateChanged, searchChanged]),
    source: combine({
        pageNumber: pageNumber$,
        filters: filters$,
        pageSize: pageSize$,
        cache: gridTokensCache$,
        search: search$,
        form: aggregationForm$,
    }),
    fn: ({pageNumber, cache, filters, pageSize, search, form}) => ({
        paging: {
            pageRef: search ? null : cache[pageNumber] ?? null,
            pageSize,
        },
        filters: mapFilters(filters),
        identityCode: search,
        storageLocationId: form.storageLocationId,
    }),
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
